module.exports = __webpack_public_path__ + "static/media/RBA.8be6e665.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/maxsizeimages/books/RBA.jpg
// module id = 1775
// module chunks = 1